export const CalcularCuota = (saldo: number, interes: number, cantidadPagos: number) => 
    (interes > 0) 
        ? (saldo * interes) / (1 - Math.pow(1 + interes, -cantidadPagos))
        : saldo / cantidadPagos;